import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBellCheck: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBellCheck"><Path d="M4.36407 9.36759C4.77896 5.46268 8.07312 2.5 12 2.5C15.9269 2.5 19.221 5.46269 19.6359 9.3676L20.5 17.5H3.5L4.36407 9.36759Z" stroke="currentColor"/><Path d="M16 17.5C16 19.7091 14.2091 21.5 12 21.5C9.79086 21.5 8 19.7091 8 17.5" stroke="currentColor"/><Path d="M8.75 10.75L10.9167 13L15.25 8.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBellCheck;
